module.exports = __webpack_public_path__ + "media/images/front/mid_g_2018-89db0da08dfd8a2f90682f0ba597feb1.png";